/** @format — List skeleton matching Documents design */

export default function DocumentsListSkeleton() {
  return (
    <div className="w-full overflow-hidden rounded-xl border border-[#e9eaeb] bg-white">
      <div className="divide-y divide-neutral-100">
        {Array.from({ length: 8 }).map((_, index) => (
          <div
            key={`list-skeleton-${index}`}
            className="flex items-center gap-3 px-2 py-[10px]"
          >
            <div className="h-10 w-10 shrink-0 animate-pulse rounded-md bg-neutral-100" />
            <div className="flex min-w-0 flex-1 flex-col gap-1.5">
              <div className="h-3 w-[55%] animate-pulse rounded bg-neutral-100" />
              <div className="h-2.5 w-[35%] animate-pulse rounded bg-neutral-100" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
